import { WHATSAPP_NUMBER } from "@/lib/whatsapp";
import Seo from "@/components/Seo";
import { MapPin, Mail, MessageCircle } from "lucide-react";

const Contact = () => (
  <>
    <Seo title="Contact" />
    <div className="lux-container pt-16 md:pt-24 pb-24 max-w-2xl">
      <p className="overline text-neutral-500 mb-3">In touch</p>
      <h1 className="font-serif-display text-4xl md:text-6xl">Talk to us</h1>
      <p className="text-neutral-600 mt-6 leading-relaxed">
        For sizing, gifting, or anything bespoke — message our stylist team on
        WhatsApp. We typically respond within minutes during shop hours.
      </p>
      <a
        href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Hello Luxsova team 👋 I have a question about your pieces.")}`}
        target="_blank"
        rel="noreferrer"
        className="btn-whatsapp mt-8 inline-flex items-center gap-2"
        data-testid="contact-whatsapp"
      >
        <MessageCircle className="w-4 h-4" />
        Message on WhatsApp
      </a>

      {/* Business identity block — real address + email so visitors,
          couriers, banks and Meta Ads review can verify the business.  */}
      <div
        className="mt-14 grid gap-6 border-t border-black/10 pt-10"
        data-testid="contact-business-details"
      >
        <div className="flex gap-4">
          <MapPin className="w-5 h-5 mt-0.5 text-neutral-500 flex-shrink-0" strokeWidth={1.5} />
          <div>
            <p className="overline text-neutral-500 mb-2">Registered address</p>
            <p
              className="text-sm text-neutral-700 leading-relaxed"
              data-testid="contact-address"
            >
              Apex Enterprises<br />
              Dhamankar Naka Flyover, Gala No. 17,<br />
              Arihant Darshan Building,<br />
              Bhiwandi, Mumbai, Maharashtra 421302, India
            </p>
          </div>
        </div>

        <div className="flex gap-4">
          <Mail className="w-5 h-5 mt-0.5 text-neutral-500 flex-shrink-0" strokeWidth={1.5} />
          <div>
            <p className="overline text-neutral-500 mb-2">Customer care</p>
            <a
              href="mailto:care@luxsova.com"
              className="text-sm text-neutral-700 hover:opacity-60"
              data-testid="contact-email"
            >
              care@luxsova.com
            </a>
            <p className="text-[11px] text-neutral-500 mt-1">
              Replies within one business day.
            </p>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default Contact;
